import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest, enhancedApiRequest } from "../../../utils";

const API_INVOICES = `${ACCOUNT_SERVICE}/invoices`;

export const invoices = {
  getAll: async ({
    filters,
    top,
    skip,
    sort,
    params,
    signal,
    enableCaching,
  } = {}) => {
    const options = await apiOptions({
      url: API_INVOICES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });

    return enhancedApiRequest(
      options,
      {},
      {
        enableCaching,
      }
    );
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_INVOICES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  createRetainage: async ({ invoiceId, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${invoiceId}/retainage`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  addPayment: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  deletePayment: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updatePayment: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getAddPaymentOptions: ({ id, data } = {}) => {
    return apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
  },
  getUpdatePaymentOptions: ({ id, data } = {}) => {
    return apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
  },
  getDeletePaymentOptions: ({ id, data } = {}) => {
    return apiOptions({
      url: `${API_INVOICES}/${id}/billing-commitments`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}`,
      method: "delete",
      data: { modifiedOn },

      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  void: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/void`,
      method: "patch",
      data: { modifiedOn },

      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  getVoidInvoiceOptions: ({ id, modifiedOn } = {}) => {
    return apiOptions({
      url: `${API_INVOICES}/${id}/void`,
      method: "patch",
      data: { modifiedOn },
      headers: { [X_API_VERSION]: API_VERSION },
    });
  },
  getInvoicePdfs: async ({ orderId, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/preview/${orderId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  getCombinedPdf: async ({ orderId, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/preview/${orderId}/combined`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  checkInvoiceVoidable: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/associated-variance-invoices`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  splitInvoiceForRetainage: async ({ id, data }) => {
    const options = await apiOptions({
      url: `${API_INVOICES}/${id}/retainage`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options);
  },
};
